import type { FloatingSelectOption } from '../../../shared/components/floating-select/floating-select';

/** Canadian province and territory codes used in address province dropdowns. */
export const CANADIAN_PROVINCE_CODES = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NS',
  'NT',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT',
] as const;

export type CanadianProvinceCode = (typeof CANADIAN_PROVINCE_CODES)[number];

/**
 * Builds province select options using translated labels from i18n keys.
 * @param translate Resolves `createShipment.provinces.<code>` to localized text.
 */
export function buildCanadianProvinceOptions(
  translate: (key: string) => string,
): FloatingSelectOption[] {
  return CANADIAN_PROVINCE_CODES.map((code) => ({
    value: code,
    label: translate(`createShipment.provinces.${code}`),
  }));
}
